import React from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";

const ConfirmationPage = () => {
  return (
    <div className="confirmation-page d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <Card className="text-center shadow" style={{ maxWidth: "500px", width: "100%" }}>
        <Card.Body className="p-5">
          <div className="mb-4">
            <div className="text-success mb-3" style={{ fontSize: "64px" }}>
              ✓
            </div>
            <h2 className="mb-3">Commande enregistrée !</h2>
            <p className="text-muted">
              Votre demande de livraison a été enregistrée avec succès.
              Nous vous contacterons rapidement pour confirmer les détails.
            </p>
          </div>

          <div className="d-grid gap-2">
            <Link to="/commande">
              <Button variant="primary" size="lg" className="w-100">
                Nouvelle commande
              </Button>
            </Link>
            <Link to="/historique">
              <Button variant="outline-secondary" size="lg" className="w-100">
                Voir l'historique
              </Button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConfirmationPage;
